<template>
	<div class="no-data" v-if="isShow"><div>未找到符合條件的數據</div></div>
	
</template>

<script>
	export default {
		name: "CN_noData",
		props:['isShow'],
		data() {
			return {
				
			}
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.no-data {
		margin-top: 160px;
		height: 400px;
		box-sizing: border-box;
		background: url(@/assets/images/icons/no-data.png) no-repeat;
		background-size: 400px auto;
		background-position: center top;
		
		text-align: center;
		
		div {
			padding-top: 260px;
			color: #999;
			font-size: 14px;
		}
	}
</style>
